var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.86,55.35c-22.93,0-41.51,18.59-41.51,41.51v318.27c0,22.93,18.59,41.51,41.51,41.51h318.26 c22.93,0,41.51-18.59,41.51-41.51v-110.7c0-15.28,12.39-27.68,27.68-27.68c15.28,0,27.68,12.39,27.68,27.68v110.7 c0,53.5-43.37,96.86-96.86,96.86H96.86C43.37,512,0,468.63,0,415.14V96.86C0,43.37,43.37,0,96.86,0h110.7 c15.29,0,27.68,12.39,27.68,27.68s-12.39,27.68-27.68,27.68H96.86z M276.75,27.68C276.75,12.39,289.14,0,304.42,0h179.9 C499.61,0,512,12.39,512,27.68v179.89c0,15.29-12.39,27.68-27.68,27.68c-15.28,0-27.68-12.39-27.68-27.68V94.49L323.99,227.14 c-10.81,10.81-28.33,10.81-39.14,0c-10.81-10.81-10.81-28.33,0-39.14L417.51,55.35H304.42C289.14,55.35,276.75,42.96,276.75,27.68z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.aac96a1b3b8f680bc8881b5cf7163be0.svg";
export { ForwardRef as ReactComponent };